var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_5749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.666 0C25.9797 2.57702e-07 28.666 2.68629 28.666 6V22C28.666 25.3137 25.9797 28 22.666 28H6.66602C3.35231 28 0.666016 25.3137 0.666016 22V6C0.666016 2.68629 3.35231 3.22128e-08 6.66602 0H22.666ZM21.9854 8.17383C16.9316 9.95623 11.8752 11.7694 6.85938 13.6455C6.73622 13.7184 6.64176 13.7934 6.56738 13.8975L6.49902 14.0127V14.1934C6.603 14.3699 6.77414 14.4697 6.96973 14.5469L10.8135 15.6621L19.4648 10.5508C19.6098 10.4615 20.0742 10.3698 19.9434 10.6416C17.6312 12.6536 15.27 14.6201 12.9268 16.6016C12.836 17.6846 12.7139 18.7782 12.6543 19.8652C12.6479 19.9802 12.6608 20.0979 12.6553 20.2129C12.8056 20.2133 12.9671 20.1741 13.0996 20.1055C13.2517 20.0263 13.5597 19.7256 13.708 19.5957C13.8959 19.4309 15.1197 18.2549 15.2236 18.2549L18.9287 20.8086C19.4835 21.1146 20.009 21.0884 20.248 20.4688C21.1339 16.6633 22.0024 12.8503 22.832 9.0332C22.8512 8.50729 22.5917 8.10628 21.9854 8.17383Z",
    fill: "#049BE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.0121C6.58267 13.8432 6.69602 13.7423 6.8605 13.645C11.8764 11.7689 16.9323 9.95635 21.9861 8.17395C22.5924 8.1064 22.8515 8.50687 22.8323 9.03278C22.0027 12.8501 21.1347 16.6634 20.2488 20.469C20.0097 21.0886 19.4843 21.1147 18.9295 20.8088L15.224 18.2548C15.12 18.2548 13.897 19.4309 13.7091 19.5957C13.5608 19.7256 13.2527 20.0259 13.1006 20.1051C12.9681 20.1739 12.8066 20.2129 12.6562 20.2125C12.6617 20.0975 12.6485 19.9801 12.6549 19.8651C12.7145 18.7779 12.8368 17.6842 12.9276 16.601C15.2708 14.6196 17.6315 12.653 19.9437 10.6411C20.0745 10.3693 19.61 10.4609 19.4651 10.5502L10.8145 15.6622L6.97001 14.5468C6.77442 14.4696 6.60397 14.3695 6.5 14.193V14.0121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_5749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramImage);
export default __webpack_public_path__ + "static/media/telegram-image.531e39012c28764926b81073b7b3f8be.svg";
export { ForwardRef as ReactComponent };